import { PropsWithChildren, createContext, useContext } from 'react';

import useCheckoutState from '@tests/StorybookTests/hooks/useCheckoutState';

import { ISO3166CountryCode } from '@config/consts';
import { ApplePayButtonColor } from '@features/ApplePay/AdyenApplePayButton/AdyenApplePayButton.static';
import { CreditCardType, ShopBundle } from '@types-internal';
import { CheckoutContextProps } from '@types-internal/CheckoutTypes';

export type CheckoutContextProviderProps = {
  country: ISO3166CountryCode;
  customerType?: string;
  autoshipmentReadyForOrder?: boolean;
  buttonColor?: ApplePayButtonColor;
  realm?: ShopBundle;
  domain?: string;
  isPaymentLoading?: boolean;
  hasErrorMessages?: boolean;
  cardUsageType?: CreditCardType;
  keycloakToken?: string;
  onPaypalApprove?: () => void;
};
export const CheckoutContext = createContext({} as CheckoutContextProps);

export const CheckoutContextProvider = ({
  children,
  country,
  customerType = '',
  buttonColor = 'black',
  autoshipmentReadyForOrder = false,
  realm = 'zooplus',
  domain,
  isPaymentLoading = false,
  hasErrorMessages = false,
  cardUsageType = 'ONE_TIME',
  keycloakToken,
  onPaypalApprove,
}: PropsWithChildren<CheckoutContextProviderProps>) => {
  const api: CheckoutContextProps = useCheckoutState(
    country,
    customerType,
    realm,
    buttonColor,
    autoshipmentReadyForOrder,
    domain,
    isPaymentLoading,
    hasErrorMessages,
    cardUsageType,
    keycloakToken,
    onPaypalApprove,
  );
  const parentContext: CheckoutContextProps = useContext(CheckoutContext);
  if (parentContext && Object.keys(parentContext).length > 0) {
    console.log('You cannot initialize the checkout state provider as it is already initialized');
    return null;
  }

  return <CheckoutContext.Provider value={api}>{children}</CheckoutContext.Provider>;
};
